import { v4 as uuidv4 } from 'uuid';
import { coreState } from '../stores/core.js';
import { useUserStore } from '../stores/useUserStore.js';

export class Profile {
    constructor({ id = uuidv4(), name, email, avatar = '', languages = [], displayed_qualification = null, signupCompleted = false, onboarding_intent = null, qualifications = [], specialties = [], stats = null, historySummary = null, venmo_handle = null }) {
        this.id = id;
        this.name = name;
        this.email = email;
        this.avatar = avatar;
        // Bio removed: "nobody would write bios these days"
        // Role removed: strictly for ShopMember RBAC now.
        // Professional titles (e.g. Course Director) must be in qualifications.
        // Location removed per user request.
        this.languages = languages;
        this.venmo_handle = venmo_handle;
        this.onboarding_intent = onboarding_intent;
        this.qualifications = qualifications;
        this.specialties = specialties;

        // Extended Profile Data (Default empty/zero for new users)
        this.stats = stats || {
            totalDives: 0
        };
        this.historySummary = historySummary || {
            totalLogs: 0,
            lastLog: 'None'
        };

        // Global Footprint Heatmap (Image URL for now, could be dynamic later)
        this.heatmap = null;


        // Explicitly selected title to display (overrides default logic of showing first qualification)
        this.displayed_qualification = displayed_qualification;
        this.createdAt = new Date().toISOString();
        this.signupCompleted = signupCompleted;
    }

    /**
     * Helper to get qualifications from the store.
     * @param {Object} store - The reactive store object
     */
    getQualifications() {
        const userStore = useUserStore();
        return userStore.getQualifications(this.id);
    }

    getSpecialties() {
        const userStore = useUserStore();
        return userStore.getSpecialties(this.id);
    }

    getNotifications() {
        const userStore = useUserStore();
        return userStore.getNotifications(this.id);
    }

    getShop() {
        // If shopId is explicitly set, try to get that
        if (this.shopId && coreState.shops.has(this.shopId)) {
            return coreState.shops.get(this.shopId);
        }
        // Fallback: This logic might need to be in a store/composable, but if we must:
        for (const member of coreState.members.values()) {
            if (member.userId === this.id) return coreState.shops.get(member.shopId);
        }
        return null;
    }

    getRole() {
        if (!this.shopId) return null;

        for (const member of coreState.members.values()) {
            if (member.userId === this.id && member.shopId === this.shopId) {
                return member.role;
            }
        }
        return null;
    }

    /**
     * derived state: isProfileComplete
     * Checks if the user has the essential "Passport" info:
     * - Name
     * - Email
     * - At least one language? (Optional but preferred)
     * - At least one Qualification (Agency/Level)
     * @param {Object} store 
     */
    isProfileComplete(store) {
        // STRICT GUARDRAIL: 
        // We rely ONLY on the explicit 'signupCompleted' flag.
        // Data presence (Name/Email from OAuth) does NOT imply completion.
        if (this.signupCompleted === true) {
            return true;
        }

        console.log("[User] Profile Incomplete: signupCompleted flag is missing/false");
        return false;
    }
}

